<template>
    <div class="infoBox">
        <div class="info">
            <div>
                <h5>公司名称：</h5>
                <el-tooltip :content="infoData.com_name" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.com_name}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>姓名：</h5>
                <el-tooltip :content="infoData.name" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.name}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>部门：</h5>
                <el-tooltip :content="infoData.bu_men" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.bu_men}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>职务：</h5>
                <el-tooltip :content="infoData.zhi_wu" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.zhi_wu}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>电话：</h5>
                <el-tooltip :content="infoData.tel" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.tel}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>手机：</h5>
                <el-tooltip :content="infoData.phone" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.phone}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>微信号：</h5>
                <el-tooltip :content="infoData.wei_xin" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.wei_xin}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>QQ号：</h5>
                <el-tooltip :content="infoData.qq" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.qq}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>旺旺号：</h5>
                <el-tooltip :content="infoData.wang_num" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.wang_num}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>邮箱：</h5>
                <el-tooltip :content="infoData.email" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.email}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>网址：</h5>
                <el-tooltip :content="infoData.url" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.url}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>地区：</h5>
                <el-tooltip :content="infoData.area" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.area}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>地址：</h5>
                <el-tooltip :content="infoData.address" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.address}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>邮编：</h5>
                <el-tooltip :content="infoData.zip_code" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.zip_code}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>备注：</h5>
                <el-tooltip :content="infoData.remark" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.remark}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>跟进状态：</h5>
                <el-tooltip :content="infoData.status_txt" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.status_txt}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>创建时间：</h5>
                <el-tooltip :content="infoData.create_time" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.create_time}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>负责人：</h5>
                <el-tooltip :content="infoData.mobile" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.mobile}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>最后备注时间：</h5>
                <el-tooltip :content="infoData.remark_time" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.remark_time}}</span>
                </el-tooltip>
            </div>
            <div>
                <h5>最后通话时间：</h5>
                <el-tooltip :content="infoData.record_time" class="item" effect="dark" placement="bottom">
                    <span>{{infoData.record_time}}</span>
                </el-tooltip>
            </div>
        </div>
        <div class="followUpRecord">
            <followUpRecord></followUpRecord>
        </div>
    </div>
</template>

<script>
import { cluesDetail } from '@/api/callCenter';
import followUpRecord from '@/views/callCenter/components/followUpRecord.vue';

export default {
    name: 'basicInfo',
    components:{
        followUpRecord
    },
    data() {
        return {
            infoData:'',

        };
    },
    created() {
        cluesDetail({id:this.$route.query.id}).then(res=>{
            if (res.code==200){
                this.infoData=res.data;
            }else {
                this.$message.error(res.msg);
            }
        })
    }
}

</script>

<style scoped lang="scss">
    .infoBox{
        //border:1px dashed #e0dbdb;
        border-radius: 5px;
        color: #606266;
        margin:0px !important;
    }
    .info{
        padding: 20px;
        background-color: #fff;
        //border-radius: 5px;
        //margin: 0px 10px;
        //width: 100%;
        display: flex;
        flex-wrap: wrap;
        border-radius: 0px 0px 5px 5px;
        div {
            width: 25%;
            margin: 5px 0px;
            display: flex;
            align-items: center;
            span{
                display: block;
                max-width: 70%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: default;
                font-size: 14px;
            }
        }
    }
    h5{
        max-width: 30%;
    }
    .followUpRecord{
        padding: 15px;
        margin: 10px 0px;
        background-color: #fff;
        border-radius: 5px;
    }
</style>